import { cn } from '@/lib/utils'
import type { CategoryIconKey } from '@/modules/products/domain/contracts'
import {
  CATEGORY_ICON_OPTIONS,
  DEFAULT_CATEGORY_ICON_KEY,
} from '../lib/category-icons'

type CategoryIconPickerProps = {
  value: CategoryIconKey | null
  onChange: (key: CategoryIconKey) => void
  className?: string
}

export function CategoryIconPicker({
  value,
  onChange,
  className,
}: CategoryIconPickerProps) {
  const selected = value ?? DEFAULT_CATEGORY_ICON_KEY

  return (
    <div
      role="radiogroup"
      aria-label="ເລືອກໄອຄອນຫມວດຫມູ່"
      className={cn(
        'grid grid-cols-5 gap-2 sm:grid-cols-5',
        className,
      )}
    >
      {CATEGORY_ICON_OPTIONS.map(({ key, label, Icon }) => {
        const active = selected === key
        return (
          <button
            key={key}
            type="button"
            role="radio"
            aria-checked={active}
            title={label}
            onClick={() => onChange(key)}
            className={cn(
              'flex flex-col items-center gap-1 rounded-xl border p-2 text-center transition-colors',
              active
                ? 'border-secondary/50 bg-primary/15 text-secondary shadow-sm'
                : 'border-secondary/15 bg-background/80 text-muted-foreground hover:border-secondary/30 hover:bg-secondary/10 hover:text-foreground',
            )}
          >
            <Icon className="size-5 shrink-0" aria-hidden />
            <span className="line-clamp-2 text-[10px] leading-tight font-medium">
              {label}
            </span>
          </button>
        )
      })}
    </div>
  )
}
